/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
// import { AgGridReact } from 'ag-grid-react';
import $ from 'jquery';
import UIGrid from '../uigrid';
// import NumericInputComponent from '../../shared/form-components/input/numeric-input';
import Notification from '../../shared/notification-modal';
// styles
// import 'ag-grid-enterprise';
import '../../styles/ag-grid.scss';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

// shared
import {
  defaultModalOptions,
} from '../../shared/constantVariable';
import {
  // decimalFormatter,
  canCellBeEditable,
  // getCellStyle,
} from '../../shared/helper';

function GridTable(props) {
  const {
    handleAfterEdit,
    // onGridReady,
    rowData,
    inputMode,
    chargeBalanceIon,
    columnDefs,
    isShowNF_Feed
  } = props;
  // const defaultCol = ['Total Anions', 'Total Cations'];
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  // const handleNegativeValue = () => {
  //   setModalOption({
  //     ...defaultModalOptions,
  //     visible: true,
  //     title: 'Warning',
  //     message: 'Feed Compositions must be a positive number',
  //     yesOrNo: false,
  //     onNo: () => setModalOption(defaultModalOptions)
  //   });
  // };
  // Define rows that need to be toggled
  const rowNumbers = [1, 2, 4, 5, 6, 7, 8, 9, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];

  // Build a selector for all affected rows
  const selector = rowNumbers.map(num => `.custom-ag-grid .row_${num}`).join(', ');
  const inputselector = rowNumbers.map(num => `.custom-ag-grid .row_${num} input`).join(', ');
  useEffect(() => {
    $('.custom-ag-grid .row_10 input').attr('disabled', 'true');
    $('.custom-ag-grid .row_23 input').attr('disabled', 'true');
    canCellBeEditable(inputMode, chargeBalanceIon);
  }, []);
  useEffect(() => {

    // Apply or remove class based on isShowNF_Feed value
    if (isShowNF_Feed) {
      $(selector).addClass('is-disabled');
      // $(inputselector).val(0);
    } else {
      $(selector).removeClass('is-disabled');
    }
  }, [isShowNF_Feed]);
  return (
    <div className="modal-background">
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <div
        className="ag-theme-alpine custom-ag-grid"
        style={{
          height: 'auto',
          width: 'auto',
          marginRight:'20px'
        }}
      >
        <UIGrid
          data={rowData}
          properties={columnDefs}
          onblur={handleAfterEdit}
        />
      </div>
    </div>
  );
}

export default GridTable;
